import { z } from 'zod';

const valueSchema = z.object({
  percentage: z.number().optional(),
  valueLcy: z.number().optional(),
});

const strictValueSchema = valueSchema.superRefine((val, ctx) => {
  if (
    typeof val.percentage === 'number' &&
    (val.percentage < 0 || val.percentage > 100)
  ) {
    ctx.addIssue({
      path: [],
      message: 'Percentage must be between 0 and 100.',
      code: z.ZodIssueCode.custom,
    });
  }

  if (typeof val.valueLcy === 'number' && val.valueLcy < 0) {
    ctx.addIssue({
      path: [],
      message: 'Amount must be 0 or greater.',
      code: z.ZodIssueCode.custom,
    });
  }
});

export const schema = z.object({
  investments: valueSchema,
  managementFees: valueSchema,
  otherExpenses: valueSchema,
  totalCallValueLcy: z.number().optional(),
});

export const allocationExceedsTotalCall = ({
  investments,
  managementFees,
  otherExpenses,
  totalCallValueLcy,
}: FormValues): boolean => {
  if (totalCallValueLcy == null) return false;

  const total =
    (investments?.valueLcy ?? 0) +
    (managementFees?.valueLcy ?? 0) +
    (otherExpenses?.valueLcy ?? 0);

  return total > totalCallValueLcy;
};

export const allocationExceedsTotalCallMessage =
  'The allocation above cannot exceed the total general capital call. Please reduce the allocation before proceeding.';

export const strictSchema = schema
  .extend({
    investments: strictValueSchema,
    managementFees: strictValueSchema,
    otherExpenses: strictValueSchema,
  })
  .superRefine((val, ctx) => {
    if (allocationExceedsTotalCall(val)) {
      ctx.addIssue({
        path: ['totalCallValueLcy'],
        message: allocationExceedsTotalCallMessage,
        code: z.ZodIssueCode.custom,
      });
    }
  });

export type FormValues = z.infer<typeof schema>;
